import { render, staticRenderFns } from "./SelectPacker.vue?vue&type=template&id=61424cfd&"
import script from "./SelectPacker.vue?vue&type=script&lang=js&"
export * from "./SelectPacker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports